import View from './view';
import React from 'react';
import {IOwnProps} from './model';

export const CreateRequestDesktop: React.FC<IOwnProps> = ({onModalClose}) => {
  return React.createElement(View, {
    onClose: onModalClose,
    onSuccessFormSubmit: onModalClose,
  });
};
